import _ from 'lodash'
import { withCompInfo } from '@wix/editor-elements-integrations'
import type { Language } from '@wix/thunderbolt-becky-types'
import { toQueryString } from '@wix/link-utils'
import type { GoogleMapDefinition, GoogleMapProps, GoogleMapDataProp } from './GoogleMap'
import { supportedLanguages } from './constants'

const buildLocations = (locations: any) => {
	return locations.map((location: any) => {
		const { link, address, latitude, longitude, title, description, linkTitle, pinIcon, pinColor } = location

		return {
			address,
			latitude,
			longitude,
			title,
			description,
			linkTitle,
			pinIcon,
			pinColor,
			link,
			locationLinkAttributes: link || {},
		}
	})
}

const getMapData = (compData: any, compProps: any) => {
	const {
		mapDragging: mapInteractive,
		showZoom,
		showDirectionsLink,
		showStreetView,
		showMapType,
		mapType,
		zoom,
	} = compProps
	const { defaultLocation, mapStyle, locations } = compData

	return {
		mapInteractive,
		showZoom,
		showDirectionsLink,
		showStreetView,
		showMapType,
		mapType,
		mapStyle: JSON.stringify(mapStyle),
		locations: buildLocations(locations),
		defaultLocation,
		zoom,
	}
}

const getLanguage = (compLang: string, userLang: Language) => {
	const preferredLanguage = compLang === 'userLang' ? userLang : compLang
	if (supportedLanguages.includes(preferredLanguage)) {
		return preferredLanguage
	}
	return 'en'
}

const getUrlQueries = (mapData: GoogleMapDataProp, language: string, id: string) => {
	const { defaultLocation, showZoom, showStreetView, showMapType } = mapData

	const urlParamsObj = _({
		defaultLocation: `${defaultLocation}`,
		showZoom,
		showStreetView,
		showMapType,
		language,
		id,
	})
		.pickBy((p: any) => p)
		.mapValues((p) => `${p}`)
		.value()

	return toQueryString(urlParamsObj)
}

export const props = withCompInfo<GoogleMapProps, GoogleMapDefinition>()(
	['compData', 'compProps', 'skin', 'language'],
	({ compData, compProps, skin, language }) => {
		const { language: compLanguage } = compProps as any
		const { id } = compData as any

		const mapData = getMapData(compData, compProps)
		const mapLanguage = getLanguage(compLanguage, language)
		const urlQueries = getUrlQueries(mapData, mapLanguage, id)

		return { skin, mapData, urlQueries }
	}
)
